import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class WhatsAppConfigService {

    constructor(private http: HttpClient) { }

    getAllWhatsAppConfigs(body: any): Observable<any> {
        return this.http.post(environment.getAllWhatsAppConfigs, body);
    }

    createWhatsAppConfig(body: any): Observable<any> {
        return this.http.post(environment.createWhatsAppConfig, body);
    }
    
    updateWhatsAppConfig(body: any): Observable<any> {
        return this.http.post(environment.updateWhatsAppConfig, body);
    }

    deleteWhatsAppConfig(body: any): Observable<any> {
        return this.http.post(environment.deleteWhatsAppConfig, body);
    }
    
    
}
